<template>
    <div class="container AlarmConfiguration">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleEditFormShow('')">新增告警项</el-button>
        <div class="config">
            <div class="config-title">
                <el-row type="flex" justify="space-between" align="center">
                    <el-col :span="4">告警项</el-col>
                    <el-col :span="2">告警类型</el-col>
                    <el-col :span="2">频率</el-col>
                    <el-col :span="5">告警描述</el-col>
                    <el-col :span="5">UID</el-col>
                    <el-col :span="5">通知对象</el-col>
                    <el-col :span="1">操作</el-col>
                </el-row>
            </div>
            <div :class="['config-item', item.id ? 'active' : '']" v-for="item of configList" :key="item.id">
                <el-row class='row' type="flex" justify="space-between" align="center">
                    <el-col class='col' :span="4"><span class='bold'>{{item.name}}</span></el-col>
                    <el-col class='col' :span="2"><span >{{item.level | alarmLevelFilter}}</span></el-col>
                    <el-col class='col' :span="2"><span >{{item.interval | timeStamp}}</span></el-col>
                    <el-col class='col' :span="5"><span >{{item.description}}</span></el-col>
                    <el-col class='col' :span="5"><span >{{item.uid}}</span></el-col>
                    <el-col class='col receiver' :span="5">
                        <el-tag class='receiver-tag' size="small" v-for="binder of item.bind_receivers" :key="binder.id" closable @close='handleRemoveReceiver(item, binder)'>{{binder.name}}</el-tag>
                    </el-col>
                    <el-col class='col' :span="1">
                        <div class="btn-area">
                            <el-dropdown>
                                <span class="el-dropdown-link">
                                    <i slot="reference" class="more-operate-btn el-icon-more-outline"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <el-button style="padding: 0 5px;" size="medium" type="text"
                                            @click="handleEditFormShow(item)">编辑</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button style="padding: 0 5px;" size="medium" type="text"
                                            @click="handleDelete(item.id)">删除</el-button>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="display:flex;justify-content:center;margin:20px 0;">
                <el-pagination background layout="prev, pager, next" :page-size="10" :total="configTotal"
                    @current-change="configListPageChange" :current-page="currentConfigPage"></el-pagination>
            </div>
        </div>
        <el-dialog :title="editForm.id ? '编辑告警' : '新增告警'" :visible.sync="editFormVisible" width="30%" @closed="handleEditFormClosed">
            <div class="event-dialog-content">
                <kbm-step :config="stepConfig" :current-step-index="editStep"></kbm-step>
                <el-form :model="editForm" v-show="editStep === 1">
                    <el-form-item label="告警项名称" label-width="100px">
                        <el-input v-model="editForm.name" placeholder="告警项名称" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="UID" label-width="100px">
                        <el-input v-model="editForm.uid" placeholder="配置UID" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="告警描述" label-width="100px">
                        <el-input type="textarea" :rows="4" v-model="editForm.description" placeholder="填写告警描述"
                            autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="频率单位" label-width="100px">
                        <el-select v-model="editForm.intervalRatio" placeholder="请选择">
                            <el-option v-for="item in intervalTypeList" :key="item.value" :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="频率" label-width="100px">
                        <!-- <el-input v-model="editForm.interval" placeholder="频率" autocomplete="off"></el-input> -->
                        <el-input-number v-model="editForm.interval" controls-position="right" :min="1">
                        </el-input-number>
                    </el-form-item>
                    <el-form-item label="告警类型" label-width="100px">
                        <el-select v-model="editForm.level" placeholder="请选择">
                            <el-option v-for="item in levelList" :key="item.value" :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-row type="flex" justify="end" v-show="editStep === 2">
                    <el-col :span="8">
                        <el-input placeholder="查找手机号" v-model="receiverSearchForm.phone"
                            @change="receiverListPageChange(1)" class="input-with-select">
                            <i class="el-icon-search el-input__icon" slot="suffix"></i>
                        </el-input>
                    </el-col>
                </el-row>
                <el-table ref="receiverTable" :data="receiverList" tooltip-effect="dark"
                    style="width: 100%;margin-top: 14px;"
                    :header-cell-style="{height: '40px',background: '#F9FAFC',color: '#A5ACB8'}" v-show="editStep === 2"
                    :row-style="{height: '40px',padding: '5px 0'}" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" :selectable="handlet"></el-table-column>
                    <el-table-column prop="name" label="姓名" width="120"></el-table-column>
                    <el-table-column prop="email" label="邮箱" min-width="120"></el-table-column>
                    <el-table-column prop="phone" label="手机号" show-overflow-tooltip></el-table-column>
                </el-table>
                <!-- <el-row type="flex" justify="center">
                    <el-col :span="6">
                        <el-pagination small layout="prev, pager, next" :page-size="5" :total="receiverTotal"
                            @current-change="receiverListPageChange" :current-page="currentReceiverPage"
                            v-show="editStep === 2"></el-pagination>
                    </el-col>
                </el-row> -->

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editFormVisible = false">取 消</el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="editStep = 1" v-if="editStep === 2">
                    上一步
                </el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="editStep = 2" v-if="editStep === 1">
                    下一步
                </el-button>
                <el-button style="margin-left: 20px;" type="primary" @click="handleSave" v-if="editStep === 2">
                    确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Core from '../../../core';
import KbmStep from '@/components/kbm-step/KbmStep';

export default {
    components: {
        KbmStep
    },
    props: {
        projectId: {
            default: 0
        }
    },
    data() {
        return {
            configList: [],
            configTotal: 0,
            currentConfigPage: 1,
            editFormVisible: false,
            editForm: {
                id: '',
                name: '',
                uid: '',
                description: '',
                interval: '',
                level: '',
                intervalRatio: 1
            },
            editStep: 1,
            stepConfig: ['告警配置', '告警通知'],
            multipleSelection: [],
            receiverList: [],
            receiverTotal: 0,
            currentReceiverPage: 1,
            receiverSearchForm: {
                phone: ''
            },
            levelList: [
                { name: '一般', value: 100 },
                { name: '严重', value: 200 },
                { name: '致命', value: 300 }
            ],
            intervalTypeList: [
                { name: '分钟', value: 1 },
                { name: '小时', value: 60 },
                { name: '天', value: 1440 }
            ]
        };
    },
    mounted() {
        this.getConfigList();
        this.getReceiverList();
    },
    methods: {
        async handleSave() {
            try {
                const {
                    alarm_model: { id: alarm_model_id }
                } = await Core.Api.AlarmModel.save(
                    this.editForm.id,
                    this.projectId,
                    this.editForm.name,
                    this.editForm.uid,
                    this.editForm.description,
                    this.editForm.interval * this.editForm.intervalRatio,
                    this.editForm.level
                );
                const receiverIds = this.multipleSelection.map((item) => item.id).toString();
                await Core.Api.Receiver.bindReceiver(alarm_model_id, receiverIds);
            } catch (error) {
                console.log(error);
            } finally {
                this.configListPageChange(1);
                this.handleEditFormClose();
            }
        },
        handleDelete(id) {
            this.$confirm('确定删除该告警项？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Core.Api.AlarmModel.delete(id).then((res) => {
                    this.configListPageChange(1);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
            });
        },
        handleEditFormShow(item) {
            if (item) {
                class EditForm {
                    constructor(id, name, uid, description, interval, level) {
                        this.id = id;
                        this.name = name;
                        this.uid = uid;
                        this.description = description;
                        this.interval = interval;
                        this.level = level;
                    }
                    intervalRatio = 1;
                }
                const { id, name, uid, description, interval, level } = item;
                this.editForm = new EditForm(id, name, uid, description, interval, level);
                this.getReceiverList(id);
            }
            this.editFormVisible = true;
        },
        handleEditFormClose() {
            this.editFormVisible = false;
        },
        handleEditFormClosed() {
            Core.Util.emptyObject(this.editForm);
            this.toggleSelection('');
            this.editStep = 1;
        },
        getConfigList() {
            Core.Api.AlarmModel.list(this.currentConfigPage, this.projectId).then((res) => {
                this.configList = res.alarm_model_list;
                this.configTotal = res.count;
            });
        },
        configListPageChange(page) {
            this.currentConfigPage = page;
            this.getConfigList();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);
        },
        getReceiverList(alarm_model_id = '') {
            Core.Api.Receiver.listAll(this.receiverSearchForm.phone, alarm_model_id).then((res) => {
                this.receiverTotal = res.total;
                this.receiverList = res.receiver_list;

                this.toggleSelection(this.receiverList);
            });
        },
        receiverListPageChange(page) {
            this.currentReceiverPage = page;
            this.getReceiverList();
        },
        toggleSelection(rows) {
            if (rows) {
                this.$nextTick(() => {
                    rows.forEach((row) => {
                        if (row.is_selected == 1) {
                            this.$refs.receiverTable.toggleRowSelection(row);
                        }
                    });
                });
            } else {
                this.$refs.receiverTable.clearSelection();
            }
        },

        // 删除通知对象
        handleRemoveReceiver(model, receiver) {
            console.log('handleRemoveReceiver model:', model, 'receiver:', receiver)
            this.$confirm(`确定将「${receiver.name}」从「${model.name}」的通知对象中移除吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Core.Api.Receiver.unbindReceiver(model.id, receiver.id).then((res) => {
                    this.configListPageChange(1);
                    this.$message.success('移除成功!');
                });
            });
        },

        handlet(row, index) {
            console.log('row, index:', row, index)
            return !row.is_selected
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    .config {
        .config-title {
            margin: 16px 0;
            padding: 0 20px;
            font-weight: 500;
            color: rgba(165, 172, 184, 1);
        }
        .config-item {
            margin-bottom: 10px;
            background: #fff;
            padding: 20px;
            position: relative;
            color: rgba(26, 41, 64, 1);
            border-radius: 4px 0 0 4px;
            &::after {
                display: block;
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                width: 4px;
                background-color: #eaedf4;
                border-radius: 4px 0 0 4px;
                z-index: 1;
            }
            &.active {
                &::after {
                    background-color: #14cfab;
                }
            }
            .btn-area {
                @include flex(row, space-between, center);
                .more-operate-btn {
                    line-height: 24px;
                    font-size: 18px;
                    color: #a9b3c4;
                    cursor: pointer;
                    transform: rotate(90deg);
                    -ms-transform: rotate(90deg); /* IE 9 */
                    -moz-transform: rotate(90deg); /* Firefox */
                    -webkit-transform: rotate(90deg); /* Safari and Chrome */
                    -o-transform: rotate(90deg); /* Opera */
                    &:hover {
                        color: #14cfab;
                    }
                }
            }
        }
    }
}
.AlarmConfiguration {
    .config {
        .row {}
        .col {
            color: #838A97;

            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            .bold {
                color: #1a2940;
                font-weight: 500;
            }
        }
        .receiver {
            margin-bottom: -5px;
            .receiver-tag {
                margin-right: 4px;
                margin-bottom: 5px;
            }
        }
    }
}
</style>